import { render, staticRenderFns } from "./EditField.vue?vue&type=template&id=2c194c83"
import script from "./EditField.vue?vue&type=script&lang=js"
export * from "./EditField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports